<script>
export const group = 'Bottom'
</script>

<script setup>
import TwoLineLowerThird from './shared/TwoLineLowerThird.vue'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const weather = computed(() => props.item.enrichment.weather)

const timeline = ref(null)
const timelineOut = ref(null)

onMounted(() => gsapTimeline({ name: 'WeatherSmall' }).add(timeline))

const { onDisappear } = useDisappearable()
onDisappear(async () => await gsapTimeline({ name: 'WeatherSmall - End' }).add(timelineOut.value()))
</script>

<template>
  <TwoLineLowerThird :title="'Weer'" :line="`${weather.short_text}  ${Math.round(weather.temperature)}°C`" @timeline="timeline = $event" @timelineOut="timelineOut = $event" />
</template>
